import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 審閱契約1 PostBack
 */
const ContractPostBack = [
    'POST',
    RouteUrlList.API_ContractPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ContractPostBack;
